export enum CartItemV2VariantEnum {
    BIG = 'big',
    SMALL = 'small',
}

export enum CartItemTypeEnum {
    SIMPLE = 'SimpleCartItem',
    SIMPLE_LOCAL = 'SimpleLocalCartItem',
    CONFIGURABLE = 'ConfigurableCartItem',
    CONFIGURABLE_LOCAL = 'ConfigurableLocalCartItem',
}
